module.exports = __webpack_public_path__ + "static/media/Flik6.f5ff7da8.pdf";